export default __webpack_public_path__ + "static/media/icon_arrow-collapse.2ac6c12d.svg";